import React from 'react';
import './SystemSettings.css';

const SystemSettings= () => {
  return (
    <div className="admin-panel">
      
      <div className="container">
       
         
       
        <main className="content">
          <h2 className="settings-title">System Settings</h2>
          <div className="settings-form">
            <div className="form-group">
              <label>Site Name</label>
              <input type="text" placeholder="Enter site name" />
            </div>
            <div className="form-group">
              <label>Facebook Profile Url</label>
              <input type="text" placeholder="Enter Facebook profile URL" />
            </div>
            <div className="form-group">
              <label>Contact Phone</label>
              <input type="text" placeholder="Enter contact phone" />
            </div>
            <div className="form-group">
              <label>Instagram Profile Url</label>
              <input type="text" placeholder="Enter Instagram profile URL" />
            </div>
            <div className="form-group">
              <label>Contact Email</label>
              <input type="text" placeholder="Enter contact email" />
            </div>
            <div className="form-group">
              <label>Linkedin Profile Url</label>
              <input type="text" placeholder="Enter Linkedin profile URL" />
            </div>
            <div className="form-group">
              <label>Contact Address</label>
              <input type="text" placeholder="Enter contact address" />
            </div>
            <div className="form-group">
              <label>Twitter Profile Url</label>
              <input type="text" placeholder="Enter Twitter profile URL" />
            </div>
            <div className="form-group">
              <label>System Logo</label>
              <input type="file" />
            </div>
            <div className="form-group">
              <label>System Favicon</label>
              <input type="file" />
            </div>

            <div className="form-group full-width">
              <h3>System Session</h3>
              <label>
                <input type="checkbox" /> Registration
              </label>
              <label>
                <input type="checkbox" /> Login
              </label>
              <label>
                <input type="checkbox" /> Maintenance
              </label>
            </div>

            <div className="form-group full-width">
              <h3>Notification Options</h3>
              <label>
                <input type="checkbox" /> Email Verification
              </label>
              <label>
                <input type="checkbox" /> Phone Verification
              </label>
              <label>
                <input type="checkbox" /> SMS Alerts
              </label>
              <label>
                <input type="checkbox" /> Email Alerts
              </label>
            </div>

            <div className="form-group full-width">
              <button className="submit-button">Submit</button>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default SystemSettings;
